module.exports = __webpack_public_path__ + "images/emails/h-email-delivery-for-web-apps-4bc7670f.gif";